import InformationFlipCard from './InformationFlipCard';

export default InformationFlipCard;